import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import {
  IBannerData,
  IConsentLetters,
  ISurgicalData,
} from "../../exports/interfaces";
import {
  fetchConsentLetters,
  fetchLowerBlepharoplasty,
  fetchLowerBlepharoplastyBanner,
} from "../../api/SurgicalDomainApi";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";

const LowerBlepharoplasty = () => {
  const { setLoading } = useLoader();
  const [lowerBlepharoplastyBanner, setLowerBlepharoplastyBanner] = useState<
    IBannerData[]
  >([]);
  const [lowerBlepharoplastyData, setLowerBlepharoplastyData] = useState<
    ISurgicalData[]
  >([]);
  const [consentLetters, setConsentLetters] = useState<IConsentLetters[]>([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([
      fetchLowerBlepharoplastyBanner(),
      fetchLowerBlepharoplasty(),
      fetchConsentLetters(),
    ])
      .then(
        ([
          lowerBlepharoplastyBannerData,
          lowerBlepharoplastyData,
          consentLettersData,
        ]) => {
          setLowerBlepharoplastyBanner(lowerBlepharoplastyBannerData);
          setLowerBlepharoplastyData(lowerBlepharoplastyData);
          setConsentLetters(consentLettersData);
          // setArchiveVideoData(videoData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        }
      )
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner
        bannerData={lowerBlepharoplastyBanner}
        page={"Lower Blepharoplasty"}
      />
      <SurgicalDomainsDescription descriptionData={lowerBlepharoplastyData} consentLetters={consentLetters} surgicalName='Lower_Blepharoplasty'/>
    </>
  );
};

export default LowerBlepharoplasty;
